import { create } from "zustand";
import { track } from "@/shared/lib/analytics";

type SeatLimitDialogState = {
  isOpen: boolean;
  limit: number;
};

type SeatLimitDialogActions = {
  openSeatLimitDialog: (limit: number) => void;
  closeSeatLimitDialog: () => void;
};

export const useSeatLimitDialogStore = create<
  SeatLimitDialogState & SeatLimitDialogActions
>((set) => ({
  isOpen: false,
  limit: 0,
  openSeatLimitDialog: (limit) => set({ isOpen: true, limit }),
  closeSeatLimitDialog: () => set({ isOpen: false, limit: 0 }),
}));

export const openSeatLimitDialog = (limit: number) => {
  track("billing.seat_limit.hit", { seat_count: limit });
  useSeatLimitDialogStore.getState().openSeatLimitDialog(limit);
};
